<template>
  <div class="border-2 border-gray-800">
    <div class="overflow-hidden text-base bg-gray-800 text-white px-4 py-3">
      <div class="float-left">
        Directors &amp; ownership
      </div>

      <div class="float-left ml-8">
        <a href="#" class="text-white text-sm" @click.prevent="add">Add a director</a>
      </div>
    </div>

    <div class="p-4">

      <template v-if="directors != null && directors.length > 0">
        <div class="flex flex-wrap">
          <div class="w-full">
            <div class="flex flex-wrap">
              <div class="w-2/3 pr-4 label-standard">Name</div>
              <div class="w-1/3">
                <div class="flex flex-wrap">
                  <div class="w-2/3 pr-4 label-standard">Ownership</div>
                </div>
              </div>
            </div>
          </div>
        </div>              

        <template v-for="(director, index) in directors">
          <div class="mt-2 flex flex-wrap">
            <div class="w-full">
              <div class="flex flex-wrap">
                <div class="w-2/3 pr-4">
                  <InputName
                    propertyKey="name"
                    :index="index"
                    :value="director.name"
                    :updateValue="updateValue"></InputName>
                </div>

                <div class="w-1/3">
                  <div class="flex flex-wrap">
                    <div class="w-2/3 pr-4" style="position:relative;">
                      <input type="text" 
                        v-model="director.percent"
                        v-on:change="updateValue(index, 'percent', $event.target.value)"
                        v-tooltip.right.notrigger="{ content: 'Invalid percentage', visible: errors['e' + index] }"
                        v-on:keyup="setOwnerships(index)"
                        :ref="'input-percent-' + index"
                        class="input-standard"
                        style="padding-right:32px;" />

                      <span class="text-gray-700" style="position:absolute;top:13px;right:20px;">%</span>
                    </div>

                    <div class="w-1/3 text-center">
                      <div class="mt-2">
                        <a href="#" class="text-gray-600 hover:text-red-500 text-sm" @click.prevent="deleteDirector(index)">
                          <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
                            <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-else>
        <div class="text-gray-900 text-base">
          You have not added any directors. 
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import InputText        from '@/shared/components/form/InputText'
  import InputName        from '@/shared/components/form/InputName'
  import { EventBus }     from '@/shared/event-bus'

  export default {

    components: {
      InputText,
      InputName,
    },

    props : {
      companyId : {
        type    : Number,
        required: true
      }
    },

    data() {
      return {
        directors: [],

        // list of error tooltip triggers
        // why? because errors {} was not getting
        // bound instantly, there was always one tick delay!
        errors : {
          e0 : false,
          e1 : false,
          e2 : false,
          e3 : false,
          e4 : false,
          e5 : false,
          e6 : false,
          e7 : false,
          e8 : false,
          e9 : false,
        }
      }
    },

    created() {
      this.getDirectors()
    },

    methods : {

      getDirectors() {
        this.apiGet({
          clientId : this.$route.params.clientId,
          companyId: this.companyId,          
        }, 'company/list-directors', (directors) => {
          this.directors = directors
        })
      },

      add() {
        this.showLoader("Adding a director...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          companyId  : this.companyId          
        }, 'company/create-director', (director) => {
          this.directors.push(director)
          this.hideLoader()          
        })
      },

      deleteDirector(index) {
        this.showLoader("Deleting a director...")
        this.apiDelete({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          directorId : this.directors[index].id          
        }, 'company/delete-director', () => {
          this.directors.splice(index, 1)
          this.hideLoader()          
        })
      },

      // a method that will receive the value and update
      // remember, this update is a little bit different 
      // because we have v-model on the input so it updates
      // automatically
      updateValue(params) {
        EventBus.$emit('set-autosave', true)
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          directorId : this.directors[params.index].id,
          key        : params.key,
          value      : params.value
        }, 'company/save-director', () => {
          EventBus.$emit('set-autosave', false)
        })
      },

      setOwnerships(index) {
        this.errors['e' + index] = false

        if(isNaN(this.directors[index].percent)) {
          this.errors['e' + index] = true  
        }

        // if the value goes over, set it to invalid
        else {
          let total = 0
         
          for(let i=0; i < this.directors.length; i++) {
            total += parseFloat(this.directors[i].percent)
          }

          if(total > 100) {
            this.errors['e' + index] = true
          }
        }
      }
    }

  }
</script>